import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { DropdownMenuItem } from "../DropdownMenuItem";
import { DropdownMenuLabel } from "../DropdownMenuLabel";
import { DropdownMenuRadioGroup } from "../DropdownMenuRadioGroup";
import { DropdownMenuRadioItem } from "../DropdownMenuRadioItem";
import { DropdownMenuSeparator } from "../DropdownMenuSeparator";
import { DropdownMenuSub } from "../DropdownMenuSub";
export const renderDropdownItems = (param)=>{
    let { options, size = "small" } = param;
    if (!options) return null;
    return options.map((option, index)=>{
        switch(option.type){
            case "children":
                return /*#__PURE__*/ _jsx(Fragment, {
                    children: option.children
                }, option.id || index);
            case "item":
                return /*#__PURE__*/ _jsx(DropdownMenuItem, {
                    className: option.className,
                    "data-id": option.id,
                    description: option.description,
                    disabled: option.disabled,
                    label: option.label,
                    truncate: option.truncate,
                    onSelect: option.onSelect,
                    prefix: option.prefix,
                    shortcut: option.shortcut,
                    size: size,
                    suffix: option.suffix
                }, option.id || index);
            case "radio-group":
                return /*#__PURE__*/ _jsx(DropdownMenuRadioGroup, {
                    onValueChange: option.onValueChange,
                    value: option.value,
                    children: renderDropdownItems({
                        options: option.options,
                        size
                    })
                }, option.id);
            case "radio-item":
                return /*#__PURE__*/ _jsx(DropdownMenuRadioItem, {
                    className: option.className,
                    "data-id": option.id,
                    description: option.description,
                    disabled: option.disabled,
                    label: option.label,
                    onSelect: option.onSelect,
                    prefix: option.prefix,
                    size: size,
                    value: option.value
                }, option.id || index);
            case "separator":
                return /*#__PURE__*/ _jsx(DropdownMenuSeparator, {
                    className: option.className,
                    "data-id": option.id
                }, option.id || index);
            case "sub":
                return /*#__PURE__*/ _jsx(DropdownMenuSub, {
                    className: option.className,
                    "data-id": option.id,
                    description: option.description,
                    disabled: option.disabled,
                    label: option.label,
                    prefix: option.prefix,
                    size: size,
                    suffix: option.suffix,
                    children: renderDropdownItems({
                        options: option.options,
                        size
                    })
                }, option.id || index);
            case "title":
                return /*#__PURE__*/ _jsx(DropdownMenuLabel, {
                    className: option.className,
                    "data-id": option.id,
                    size: size,
                    children: option.label
                }, option.id || index);
            default:
                return null;
        }
    });
};
